<cc-text-input
    #input
    [(value)]="value"
    [size]="'fit-to-parent'"
    [inputPadding]="'8px'"
>
</cc-text-input>
